export class Calculate{
    cpa(totalCost: number, totalSales: number): number {
        if (!totalCost || !totalSales) return 0;
        const average = totalCost / totalSales;
        return Math.round(average);
    }

    percentageChange(previous: number, current: number): number {
        if (previous === 0) {
          // cannot divide by zero — choose your handling strategy
          return 0;
        }
        const change = ((current - previous) / previous) * 100;
        // return integer percent:
        return Math.round(change);
        // or, for two decimals:
        // return Number(change.toFixed(2));
      }

    percentage(current: number, total: number): number {
        if (!current || !total) return 0;
        const percentage = (current / total) * 100;
        return Math.round(percentage);
    }

    ratio(a: number, b: number): number {
        if (!a || !b) return 0;
        const ratio = a / b;
        return ratio;
    }
}